export default {
    data() {
        return {
            // 查询参数
            searchForm: {},
            // 表格数据总数
            total: 0,
            // key值
            idKey: 'id',
            // 是否执行初始化表格
            initLoad: true,
            // 列表数据
            tableList: [],
            // 列表选中项
            tableSelected: [],
            // 表格加载
            tableListLoading: false,
            // 请求地址
            host: process.env.VUE_APP_URL,
            // 操作按钮类型
            actionType: '',
            // 新增编辑弹框遮罩
            addOrEditOpen: false,
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 选中数组
            ids: []
        }
    },
    mounted() {
        if (this.initLoad) {
            this.initList()
        }
    },
    methods: {
        // 表格排序
        sortChange(val) {
            // console.log(val)
            this.searchForm.sortFiled = val.prop
            if (val.order == 'ascending') {
                this.searchForm.sortOrder = 'asc'
            }
            // eslint-disable-next-line eqeqeq
            if (val.order == 'descending') {
                this.searchForm.sortOrder = 'desc'
            }
            if (val.order == null) {
                this.searchForm.sortOrder = ''
            }
            this.initList()
        },
        // 初始化表格
        async initList() {
            let fn = this.api.list
            this.tableListLoading = true
            this.tableSelected = []
            await fn(this.searchForm).then((res) => {
                this.total = res.data.total
                this.tableList = res.data.records
            }).catch((err) => {

            })
            // 解析开始时间和结束时间
            // fn &&
            //     fn(this.addDateRange(this.searchForm, this.searchForm.dateRange))
            //         .then((res) => {
            //             this.tableListLoading = false
            //             const { rows, total } = res
            //             this.total = parseInt(total)
            //             this.tableList = rows
            //             console.log(this.tableList)
            //         })
            //         .catch((err) => {
            //             console.log(err)
            //             this.tableListLoading = false
            //         })
        },
        // 重置表格
        resetList() {
            // this.searchForm.pageNum = 1
            this.initList()
        },
        // 表格多选框选中数据
        // handleSelectionChange(selection) {
        //     this.tableSelected = selection
        //     this.ids = selection.map((item) => item[this.idKey])
        //     this.single = selection.length != 1
        //     this.multiple = !selection.length
        // },
        // 点击新增按钮，唤起弹框
        handleAdd() {
            this.actionType = 'add'
            this.addOrEditOpen = true
        },
        // 点击编辑按钮，唤起弹框
        handleEdit() {
            this.actionType = 'edit'
            this.addOrEditOpen = true
        },
        // 新增编辑提交按钮
        async submitForm(res) {
            try {
                this.$refs['form'].validate((valid, err) => {
                    if (valid) {
                        this.btnLoading = true
                        if (this.actionType === 'edit') {
                            let fn = this.api.edit
                            fn(this.form).then((response) => {
                                this.addOrEditOpen = false
                                this.btnLoading = false
                                this.$message.success('修改成功')
                                this.initList()
                            })
                        } else if (this.actionType === 'add') {
                            let fn = this.api.add
                            fn(this.form).then((response) => {
                                this.addOrEditOpen = false
                                this.btnLoading = false
                                this.$message.success('添加成功');
                                this.initList()
                            })
                        }
                    } else {
                        this.form.category_ids = res.split(',')
                        this.btnLoading = false
                        if (this.isFormErr) {
                            Object.keys(err).map((key) => {
                                setTimeout(() => {
                                    this.$modal.msgError(err[key][0].message)
                                }, 100)
                            })
                        }
                    }
                })
            } catch (err) {
                this.btnLoading = false
            }
        },
        // 新增编辑弹框关闭
        cancel() {
            this.addOrEditOpen = false
            this.reset()
        },
        // 查询方法
        searchChange() {
            // this.searchForm.pageNum = 1
            this.initList()
        },
        // 查询重置
        searchReset() {
            // this.searchForm = {}
            this.$refs.queryForm.resetFields()
            this.resetList()
        },
        handleSelectionChange(selection) {
            this.tableSelected = selection
            this.ids = selection.map((item) => item[this.idKey]).join(',')
            this.single = selection.length != 1
            this.multiple = !selection.length
        },
        // 批量删除
        batchDel() {
            // const userType = this.tableSelected.find((item) => item.userType === '0')
            // if (userType) return this.$modal.msgWarning('存在内部用户不可删除')
            let delFn = this.api.dels
            let that = this
            if (!this.tableSelected.length) {
                this.$message.error('请选中至少一条记录')
                // this.$modal.msgWarning('请选中至少一条记录')
                return
            }
            this.$confirm(`确定删除?`, `批量删除`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                const res = await delFn(this.ids);
                if (res.code !== 200) return this.$message.error("删除失败");
                this.$message.success(`删除成功!`);
                this.initList();
            });
            // this.$message.('此操作将永久删除这些记录, 是否继续?').then(() => {
            //     delFn(this.ids).then((res) => {
            //         this.$message.success('删除成功')

            //         that.initList()
            //     })
            // })
        },
        // 添加日期
        addDateRange(params, dateRange, propName) {
            let search = params;
            search.params = typeof (search.params) === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
            dateRange = Array.isArray(dateRange) ? dateRange : [];
            if (typeof (propName) === 'undefined') {
                search.params['beginTime'] = dateRange[0];
                search.params['endTime'] = dateRange[1];
            } else {
                search.params['begin' + propName] = dateRange[0];
                search.params['end' + propName] = dateRange[1];
            }
            return search;
        },
        // 单挑删除
        async singleDel(row, idKey, ...args) {
            const delFn = this.api.del
            const text = args.length
                ? `是否删除这条数据`
                : `是否删除这条数据`
            this.$confirm(text, '删除数据', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await delFn(idKey)
                if (res.code !== 200) return this.$message.error(res.msg ? res.msg : '删除失败!')
                this.$message.success('删除成功');
                this.initList()
            })
        },
    }
}



//////////////////
// WEBPACK FOOTER
// ./mixins/table-common.js
// module id = null
// module chunks = 